(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tefat-cart-page"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cartForm = document.getElementById('cart-page-form');
    if (!cartForm) return;

    const qtyButtons = cartForm.querySelectorAll('.tefat-cart-page__qty-btn');
    qtyButtons.forEach(btn => {
      btn.addEventListener('click', async () => {
        const action = btn.dataset.action;
        const line = btn.dataset.line;
        const input = cartForm.querySelector(`input[data-line="${line}"]`);
        
        if (!input) return;
        
        let value = parseInt(input.value) || 1;
        let newValue = value;
        
        if (action === 'increase') {
          newValue = value + 1;
        } else if (action === 'decrease' && value > 0) {
          newValue = value - 1;
        }
        
        input.value = newValue;
        
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              line: parseInt(line),
              quantity: newValue
            })
          });
          
          if (response.ok) {
            window.location.reload();
          }
        } catch (error) {
          console.error('Cart update failed:', error);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tefat-cart"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const cartDrawer = document.getElementById('tefat-cart-drawer');
      if (!cartDrawer) return;
  
      const closeDrawer = () => {
        window.tefatCart?.close();
      };

      const applyCartDrawer = (cart) => {
        const cartCount = document.getElementById('tefat-cart-count');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          cartCount.dataset.cartCount = cart.item_count;
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));

        const sectionHTML = cart.sections && cart.sections['tefat-cart'];
        const liveContainer = cartDrawer.querySelector('.tefat-cart-drawer__container');
        if (sectionHTML && liveContainer) {
          const nyContainer = new DOMParser()
            .parseFromString(sectionHTML, 'text/html')
            .querySelector('.tefat-cart-drawer__container');
          if (nyContainer) {
            liveContainer.innerHTML = nyContainer.innerHTML;
          }
        }
      };

      const updateLine = async (line, newValue) => {
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              line: parseInt(line, 10),
              quantity: newValue,
              sections: 'tefat-cart',
              sections_url: window.location.pathname
            })
          });

          if (response.ok) {
            const cart = await response.json();
            applyCartDrawer(cart);
          }
        } catch (error) {
          console.error('Cart update failed:', error);
        }
      };

      cartDrawer.addEventListener('click', async (e) => {
        const closeBtn = e.target.closest('[data-close-cart]');
        if (closeBtn) {
          e.preventDefault();
          closeDrawer();
          return;
        }

        const removeBtn = e.target.closest('.tefat-cart-drawer__remove');
        if (removeBtn) {
          e.preventDefault();
          e.stopPropagation();
          const line = removeBtn.dataset.line;
          if (!line) return;
          await updateLine(line, 0);
          return;
        }

        const qtyBtn = e.target.closest('.tefat-cart-drawer__qty-btn');
        if (!qtyBtn) return;

        e.preventDefault();

        const action = qtyBtn.dataset.action;
        const line = qtyBtn.dataset.line;
        if (!action || !line) return;

        const input = cartDrawer.querySelector('input[data-line="' + line + '"]');
        if (!input) return;

        let value = parseInt(input.value, 10) || 1;
        let newValue = value;

        if (action === 'increase') {
          newValue = value + 1;
        } else if (action === 'decrease' && value > 0) {
          newValue = value - 1;
        }

        input.value = newValue;
        await updateLine(line, newValue);
      });
  
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && cartDrawer.getAttribute('aria-hidden') === 'false') {
          window.tefatCart?.close();
        }
      });
  
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tefat-collection-default-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  var cycleInterval = 400;
  var isCoarse = window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches;

  function initWrapper(wrapper) {
    if (wrapper.dataset.hoverInit === '1') return;
    wrapper.dataset.hoverInit = '1';
    var hoverType = wrapper.dataset.hoverType;
    var hoverImg = wrapper.querySelector('.product-card__image--hover, .merch-card__image--hover');
    var primaryImg = wrapper.querySelector('.product-card__image--primary, .merch-card__image--primary');
    if (!primaryImg) return;
    var cycleTimer = null;
    var cycleIndex = 0;
    var cycleImages = [];

    if (isCoarse) {
      var swipeImages = [];
      var primarySrc = primaryImg && (primaryImg.currentSrc || primaryImg.src);
      if (primarySrc) swipeImages.push(primarySrc);
      if (wrapper.dataset.cycleImages) {
        wrapper.dataset.cycleImages.split(',').forEach(function(u) {
          if (u && swipeImages.indexOf(u) === -1) swipeImages.push(u);
        });
      }
      if (wrapper.dataset.gifSrc && swipeImages.indexOf(wrapper.dataset.gifSrc) === -1) {
        swipeImages.push(wrapper.dataset.gifSrc);
      }
      if (swipeImages.length < 2) return;
      swipeImages.forEach(function(url) { var p = new Image(); p.src = url; });

      var swipeIndex = 0;
      var startX = 0;
      var startY = 0;
      var lastSwipe = false;
      var threshold = 30;

      wrapper.addEventListener('touchstart', function(e) {
        if (!e.touches || !e.touches[0]) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      wrapper.addEventListener('touchend', function(e) {
        var t = (e.changedTouches && e.changedTouches[0]) || null;
        if (!t) return;
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;
        swipeIndex = dx < 0
          ? (swipeIndex + 1) % swipeImages.length
          : (swipeIndex - 1 + swipeImages.length) % swipeImages.length;
        primaryImg.src = swipeImages[swipeIndex];
        lastSwipe = true;
      });

      wrapper.addEventListener('click', function(e) {
        if (lastSwipe) { e.preventDefault(); lastSwipe = false; }
      });

      return;
    }

    if (hoverType === 'gif' && wrapper.dataset.gifSrc) {
      wrapper.addEventListener('mouseenter', function() {
        hoverImg.src = wrapper.dataset.gifSrc;
        hoverImg.style.opacity = '1';
        primaryImg.style.opacity = '0';
      });
      wrapper.addEventListener('mouseleave', function() {
        hoverImg.style.opacity = '0';
        primaryImg.style.opacity = '1';
      });
    } else if (hoverType === 'cycle' && wrapper.dataset.cycleImages) {
      cycleImages = wrapper.dataset.cycleImages.split(',');

      cycleImages.forEach(function(url) {
        var preloader = new Image();
        preloader.src = url;
      });

      wrapper.addEventListener('mouseenter', function() {
        cycleIndex = 0;
        hoverImg.src = cycleImages[cycleIndex];
        hoverImg.style.opacity = '1';
        primaryImg.style.opacity = '0';
        
        cycleTimer = setInterval(function() {
          cycleIndex = (cycleIndex + 1) % cycleImages.length;
          hoverImg.src = cycleImages[cycleIndex];
        }, cycleInterval);
      });
      
      wrapper.addEventListener('mouseleave', function() {
        if (cycleTimer) {
          clearInterval(cycleTimer);
          cycleTimer = null;
        }
        hoverImg.style.opacity = '0';
        primaryImg.style.opacity = '1';
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-hover-type]').forEach(initWrapper);
  }

  initAll();

  if (window.__tefatGridLoadMoreInit) return;
  window.__tefatGridLoadMoreInit = true;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn || btn.dataset.loading === '1') return;
    var sectionId = btn.dataset.loadMore;
    var grid = document.querySelector('[data-grid-products="' + sectionId + '"]');
    var nextUrl = btn.dataset.nextUrl;
    if (!grid || !nextUrl) return;

    btn.dataset.loading = '1';
    btn.disabled = true;
    var origLabel = btn.textContent;
    btn.textContent = 'LOADING...';

    fetch(nextUrl).then(function(res) { return res.text(); }).then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-grid-products="' + sectionId + '"]');
      if (newGrid) {
        Array.from(newGrid.children).forEach(function(c) { grid.appendChild(c); });
      }
      var newBtn = doc.querySelector('[data-load-more="' + sectionId + '"]');
      if (newBtn && newBtn.getAttribute('data-next-url')) {
        btn.dataset.nextUrl = newBtn.getAttribute('data-next-url');
        btn.textContent = origLabel;
        btn.disabled = false;
        btn.dataset.loading = '0';
      } else {
        var wrap = btn.parentElement;
        if (wrap) wrap.remove(); else btn.remove();
      }
      initAll(grid);
    }).catch(function() {
      btn.disabled = false;
      btn.dataset.loading = '0';
      btn.textContent = origLabel;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tefat-collection-disk-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  var cycleInterval = 400;
  var desktopHover = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
  var mobil = window.matchMedia('(max-width: 767px)');

  function initWrapper(wrapper) {
    if (wrapper.dataset.hoverInit === '1') return;
    wrapper.dataset.hoverInit = '1';
    var typ = wrapper.dataset.hoverType;
    if (typ === 'none') return;
    var hover = wrapper.querySelector('.product-card__image--hover, .merch-card__image--hover');
    var primar = wrapper.querySelector('.product-card__image--primary, .merch-card__image--primary');
    if (!hover || !primar) return;
    var visa = function(h, p) {
      hover.style.opacity = h;
      primar.style.opacity = p;
    };

    var index = 0, timer = null, startX = null, startY = null, svepte = false;
    var bindSvep = function(bilder, visaIndex) {
      if (bilder.length <= 1) return;
      bilder.forEach(function(url) { var f = new Image(); f.src = url; });
      wrapper.addEventListener('touchstart', function(e) {
        if (!mobil.matches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        svepte = false;
      }, { passive: true });
      wrapper.addEventListener('touchend', function(e) {
        if (!mobil.matches || startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = startY = null;
        if (Math.abs(dx) < wrapper.clientWidth * 0.12 || Math.abs(dx) < Math.abs(dy)) return;
        svepte = true;
        index = (index + (dx < 0 ? 1 : -1) + bilder.length) % bilder.length;
        visaIndex(index);
      }, { passive: true });
      wrapper.addEventListener('click', function(e) { if (svepte) { e.preventDefault(); svepte = false; } });
    };

    if (typ === 'gif' && wrapper.dataset.gifSrc) {
      var gifBilder = [wrapper.dataset.gifSrc];
      var visaGif = function(i) {
        if (i > 0) hover.src = gifBilder[0];
        visa(i > 0 ? '1' : '0', i > 0 ? '0' : '1');
      };
      bindSvep([primar.currentSrc || primar.src, gifBilder[0]].filter(Boolean), visaGif);
      wrapper.addEventListener('mouseenter', function() {
        if (!desktopHover.matches) return;
        hover.src = wrapper.dataset.gifSrc;
        visa('1', '0');
      });
      wrapper.addEventListener('mouseleave', function() {
        if (!desktopHover.matches) return;
        visa('0', '1');
      });
      return;
    }
    if (typ !== 'cycle' || !wrapper.dataset.cycleImages) return;

    var bilder = wrapper.dataset.cycleImages.split(',');
    if (bilder.length <= 1) return;
    bilder.forEach(function(url) { var f = new Image(); f.src = url; });
    var visaIndex = function(i) {
      if (i > 0) hover.src = bilder[i];
      visa(i > 0 ? '1' : '0', i > 0 ? '0' : '1');
    };
    bindSvep(bilder, visaIndex);

    wrapper.addEventListener('mouseenter', function() {
      if (!desktopHover.matches) return;
      index = 0;
      hover.src = bilder[0];
      visa('1', '0');
      timer = setInterval(function() {
        index = (index + 1) % bilder.length;
        hover.src = bilder[index];
      }, cycleInterval);
    });
    wrapper.addEventListener('mouseleave', function() {
      if (timer) { clearInterval(timer); timer = null; }
      if (desktopHover.matches) visa('0', '1');
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-hover-type]').forEach(initWrapper);
  }

  initAll();

  if (window.__tefatGridLoadMoreInit) return;
  window.__tefatGridLoadMoreInit = true;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn || btn.dataset.loading === '1') return;
    var sectionId = btn.dataset.loadMore;
    var grid = document.querySelector('[data-grid-products="' + sectionId + '"]');
    var nextUrl = btn.dataset.nextUrl;
    if (!grid || !nextUrl) return;

    btn.dataset.loading = '1';
    btn.disabled = true;
    var origLabel = btn.textContent;
    btn.textContent = 'LOADING...';

    fetch(nextUrl).then(function(res) { return res.text(); }).then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-grid-products="' + sectionId + '"]');
      if (newGrid) {
        Array.from(newGrid.children).forEach(function(c) { grid.appendChild(c); });
      }
      var newBtn = doc.querySelector('[data-load-more="' + sectionId + '"]');
      if (newBtn && newBtn.getAttribute('data-next-url')) {
        btn.dataset.nextUrl = newBtn.getAttribute('data-next-url');
        btn.textContent = origLabel;
        btn.disabled = false;
        btn.dataset.loading = '0';
      } else {
        var wrap = btn.parentElement;
        if (wrap) wrap.remove(); else btn.remove();
      }
      initAll(grid);
    }).catch(function() {
      btn.disabled = false;
      btn.dataset.loading = '0';
      btn.textContent = origLabel;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tefat-collection-merch-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  var cycleInterval = 400;

  function initWrapper(wrapper) {
    if (wrapper.dataset.hoverInit === '1') return;
    wrapper.dataset.hoverInit = '1';
    const typ = wrapper.dataset.hoverType;
    const mediaCount = parseInt(wrapper.dataset.mediaCount || '0', 10);
    if (mediaCount <= 1 || typ === 'none') return;
    const hover = wrapper.querySelector('.product-card__image--hover, .merch-card__image--hover');
    const primar = wrapper.querySelector('.product-card__image--primary, .merch-card__image--primary');
    if (!hover || !primar) return;
    const mobil = window.matchMedia('(max-width: 767px)');
    const visa = (h, p) => { hover.style.opacity = h; primar.style.opacity = p; };

    if (typ === 'gif' && wrapper.dataset.gifSrc) {
      wrapper.addEventListener('mouseenter', () => { if (!mobil.matches) { hover.src = wrapper.dataset.gifSrc; visa('1', '0'); } });
      wrapper.addEventListener('mouseleave', () => { if (!mobil.matches) visa('0', '1'); });
      return;
    }
    if (typ !== 'cycle' || !wrapper.dataset.cycleImages) return;

    const bilder = wrapper.dataset.cycleImages.split(',');
    if (bilder.length <= 1) return;
    bilder.forEach((url) => { const f = new Image(); f.src = url; });

    let index = 0, timer = null, startX = null, startY = null, svepte = false;
    const visaIndex = (i) => { if (i > 0) hover.src = bilder[i]; visa(i > 0 ? '1' : '0', i > 0 ? '0' : '1'); };

    wrapper.addEventListener('mouseenter', () => {
      if (mobil.matches) return;
      index = 0; hover.src = bilder[0]; visa('1', '0');
      timer = setInterval(() => { index = (index + 1) % bilder.length; hover.src = bilder[index]; }, cycleInterval);
    });
    wrapper.addEventListener('mouseleave', () => {
      if (timer) { clearInterval(timer); timer = null; }
      if (!mobil.matches) visa('0', '1');
    });

    wrapper.addEventListener('touchstart', (e) => {
      if (!mobil.matches || e.touches.length !== 1) return;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; svepte = false;
    }, { passive: true });
    wrapper.addEventListener('touchend', (e) => {
      if (startX === null || !mobil.matches) return;
      const dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
      startX = startY = null;
      if (Math.abs(dx) < wrapper.clientWidth * 0.12 || Math.abs(dx) < Math.abs(dy)) return;
      svepte = true;
      index = (index + (dx < 0 ? 1 : -1) + bilder.length) % bilder.length;
      visaIndex(index);
    }, { passive: true });
    wrapper.addEventListener('click', (e) => { if (svepte) { e.preventDefault(); svepte = false; } });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-hover-type]').forEach(initWrapper);
  }

  initAll();

  if (window.__tefatGridLoadMoreInit) return;
  window.__tefatGridLoadMoreInit = true;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn || btn.dataset.loading === '1') return;
    var sectionId = btn.dataset.loadMore;
    var grid = document.querySelector('[data-grid-products="' + sectionId + '"]');
    var nextUrl = btn.dataset.nextUrl;
    if (!grid || !nextUrl) return;

    btn.dataset.loading = '1';
    btn.disabled = true;
    var origLabel = btn.textContent;
    btn.textContent = 'LOADING...';

    fetch(nextUrl).then(function(res) { return res.text(); }).then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-grid-products="' + sectionId + '"]');
      if (newGrid) {
        Array.from(newGrid.children).forEach(function(c) { grid.appendChild(c); });
      }
      var newBtn = doc.querySelector('[data-load-more="' + sectionId + '"]');
      if (newBtn && newBtn.getAttribute('data-next-url')) {
        btn.dataset.nextUrl = newBtn.getAttribute('data-next-url');
        btn.textContent = origLabel;
        btn.disabled = false;
        btn.dataset.loading = '0';
      } else {
        var wrap = btn.parentElement;
        if (wrap) wrap.remove(); else btn.remove();
      }
      initAll(grid);
    }).catch(function() {
      btn.disabled = false;
      btn.dataset.loading = '0';
      btn.textContent = origLabel;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tefat-contact-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var form = document.querySelector('.tefat-kontakt__formular');
  if (!form) return;
  var button = form.querySelector('.tefat-kontakt__skicka');
  if (!button) return;
  var isSuccess = form.dataset.formSuccess === 'true';
  if (!isSuccess) return;
  var successText = form.dataset.successText || 'THANK YOU!';
  var defaultText = button.dataset.defaultText || button.textContent;
  var delay = parseInt(form.dataset.successDelay, 10) || 4500;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setButtonText(text) {
    button.textContent = text;
  }

  if (window.gsap && !reduced) {
    var tl = gsap.timeline();
    tl.to(button, { autoAlpha: 0, duration: 0.2 })
      .add(function() { setButtonText(successText); })
      .to(button, { autoAlpha: 1, duration: 0.2 })
      .to({}, { duration: delay / 1000 })
      .to(button, { autoAlpha: 0, duration: 0.2 })
      .add(function() { setButtonText(defaultText); })
      .to(button, { autoAlpha: 1, duration: 0.2 });
  } else {
    setButtonText(successText);
    setTimeout(function() { setButtonText(defaultText); }, delay);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tefat-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  const cartCountEl = document.getElementById('tefat-cart-count');
  const cartLink = document.getElementById('tefat-cart-link');
  
  if (!cartCountEl) return;

  function animateCartUpdate(newCount) {
    var currentCount = parseInt(cartCountEl.dataset.cartCount, 10) || 0;
    if (newCount === currentCount) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reduced && cartLink && window.gsap) {
      gsap.fromTo(
        cartLink,
        { scale: 1 },
        {
          scale: 1.1,
          duration: 0.14,
          ease: 'power2.out',
          yoyo: true,
          repeat: 1,
          transformOrigin: '50% 50%',
        }
      );
    }

    if (reduced || !window.gsap) {
      cartCountEl.textContent = String(newCount);
      cartCountEl.dataset.cartCount = String(newCount);
      return;
    }

    var o = { n: currentCount };
    gsap.to(o, {
      n: newCount,
      duration: 0.28,
      ease: 'power2.out',
      onUpdate: function () {
        cartCountEl.textContent = String(Math.round(o.n));
      },
      onComplete: function () {
        cartCountEl.textContent = String(newCount);
        cartCountEl.dataset.cartCount = String(newCount);
      },
    });
  }

  async function fetchAndUpdateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      animateCartUpdate(cart.item_count);
    } catch (error) {
      console.error('Kunde inte hämta cart:', error);
    }
  }

  document.addEventListener('cart:updated', (event) => {
    if (event.detail && typeof event.detail.item_count !== 'undefined') {
      animateCartUpdate(event.detail.item_count);
    } else {
      fetchAndUpdateCart();
    }
  });

  document.addEventListener('shopify:section:load', fetchAndUpdateCart);

  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);
    const url = args[0];
    
    if (typeof url === 'string' && (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    )) {
      setTimeout(fetchAndUpdateCart, 100);
    }
    
    return response;
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return originalXHROpen.apply(this, arguments);
  };

  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', function() {
      if (this._url && (
        this._url.includes('/cart/add') ||
        this._url.includes('/cart/change') ||
        this._url.includes('/cart/update') ||
        this._url.includes('/cart/clear')
      )) {
        setTimeout(fetchAndUpdateCart, 100);
      }
    });
    return originalXHRSend.apply(this, arguments);
  };
})();

  } catch(e) { console.error(e); }
})();
})();
